import './member-balance-list.scss'
import { useLogger } from '@omnia/ui/src/lib'
import { getMemberBalances } from '@vista-digital/occ-domain'
import { Button, MemberBalanceSkeleton, useMemberContext, useOccConfig } from '@vista-digital/occ-ui'
import type { FC } from 'react'
import { navigationService } from '@/common/services/navigation.service'
import { MemberBalanceComponent } from './subcomponents/member-balance'
import { getMemberBalanceProps } from './utils/getMemberBalanceProps'

export const MemberBalanceList: FC = () => {
    const logger = useLogger('MemberBalanceList')
    const { member } = useMemberContext()
    const { enableSkeletonLoadingIndicators } = useOccConfig()

    const props = getMemberBalanceProps()

    if (!member) {
        return enableSkeletonLoadingIndicators ? (
            <div className="member-balance-list">
                <MemberBalanceSkeleton />
                <MemberBalanceSkeleton />
                <MemberBalanceSkeleton />
            </div>
        ) : null
    }

    const balanceTypeIds = getMemberBalances()
        ?.map(balance => balance.balanceTypeId)
        .filter(Boolean) as number[]

    logger.trace('Rendering', { balanceTypeIds, props })

    return (
        <div className="member-balance-list">
            <div className="member-balance-list__item">
                {balanceTypeIds.map(balanceTypeId => (
                    <MemberBalanceComponent key={`balance-${balanceTypeId}`} {...props} balanceTypeId={balanceTypeId} />
                ))}
            </div>
            <Button
                children={'Recargar Saldo'}
                onClick={() => navigationService.goToPage('Member', undefined, undefined, 'MemberRechargePoints')}
                className="recharge-button"
            />
        </div>
    )
}
